import useFetchWDACManagedInstallers from './useFetchWDACManagedInstallers';
import WdacManagedInstallersTable from './WdacManagedInstallersTable';

const WdacManagedInstallers = () => {
  const {
    isLoading,
    data: managedInstallerList,
    lastElementRef,
    isFetching,
    count,
    query,
  } = useFetchWDACManagedInstallers();

  return (
    <WdacManagedInstallersTable
      isLoading={isLoading}
      isFetching={isFetching}
      managedInstallerList={managedInstallerList}
      lastElementRef={lastElementRef}
      totalCount={count}
      query={query}
    />
  );
};

export default WdacManagedInstallers;
